import { Upc } from './upc';

export class Brand {
    brandId: number;
    brandName: string;
    upcCount: number;
    createdDate: Date;
    /** Detail UPCs — present when loading a single brand for review. */
    upcs?: Upc[];

    constructor(options?: Partial<Brand>) {
        Object.assign(this, options);
    }
}
